export const $srpList = $("#srp-list");



// WEBPACK FOOTER //
// ./srp/views/search-results/list.js